import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useScrollPosition from '@react-hook/window-scroll';

import i18n from '../../../i18n';

import ContactsFone from 'assets/images/contacts_fone.png';
import Foto_1 from 'assets/images/contact_1.png';
import Foto_2 from 'assets/images/contact_2.png';
import Foto_3 from 'assets/images/contact_3.png';
import Foto_4 from 'assets/images/contact_4.png';

import { Text, TextTypography } from 'components/Text/Text';
import { Grid, useMediaQuery } from '@material-ui/core';

import { Header } from 'components/Header/Header';
import { FooterInternalPages } from 'components/Footer/FooterInternalPages';

const useStyles = makeStyles(theme => ({
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    headerContainer: {
        position: 'fixed',
        width: '100%',
        top: 0,
        left: 0,
        zIndex: 1,
        backgroundColor: (props: { scrollY: number }) => (props.scrollY > 664 ? '#FBFEF9' : null),
    },
    tagline: {
        height: 664,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: `url(${ContactsFone}) no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: 'right',
    },

    taglineText: {
        maxWidth: 537,
        marginLeft: theme.spacing(17.75),
        color: '#FFFFFF',
        textShadow: '0px 0px 60px rgba(0, 0, 0, 0.8)',
        [theme.breakpoints.down(1280)]: {
            marginLeft: theme.spacing(5),
        },
        [theme.breakpoints.down(768)]: {
            marginLeft: theme.spacing(4),
        },
        [theme.breakpoints.down(480)]: {
            marginLeft: theme.spacing(2),
        },
    },
    additionalContainer: {
        width: '100%',
        padding: theme.spacing(10, 17.75),
        margin: '0 auto',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(1280)]: {
            padding: theme.spacing(10, 5),
        },
        [theme.breakpoints.down(960)]: {
            padding: theme.spacing(8, 5),
        },
        [theme.breakpoints.down(768)]: {
            padding: theme.spacing(6, 4),
        },
        [theme.breakpoints.down(480)]: {
            padding: theme.spacing(6, 2),
        },
    },
    additionalTitle: {
        width: '100%',
        marginTop: theme.spacing(7),
        '&:first-child': {
            marginTop: 0,
        },
        [theme.breakpoints.down(960)]: {
            marginTop: theme.spacing(8),
        },
        [theme.breakpoints.down(768)]: {
            marginTop: theme.spacing(6),
        },
        [theme.breakpoints.down(640)]: {
            marginTop: theme.spacing(5),
        },
    },
    additionalTitleText: {
        letterSpacing: -1,
        [theme.breakpoints.down(321)]: {
            fontSize: 24,
            lineHeight: 1.33,
        },
    },
    additionalSubTitle: {
        width: 'inherit',
        marginTop: theme.spacing(3),
    },
    grid: {
        marginTop: theme.spacing(6),
        [theme.breakpoints.down(960)]: {
            marginTop: theme.spacing(4),
        },
    },
    contactImg: {
        width: '100%',
        // objectFit: 'fill',
        // maxHeight: '100%',
        borderRadius: theme.spacing(1),
    },
    footerContainer: {
        width: '100%',
        margin: '0 auto',
    },
    contactTitle: {
        marginTop: theme.spacing(3),
    },
    contactSubTitle: {
        marginTop: theme.spacing(1),
    },
}));

export const Contacts = () => {
    const scrollY = useScrollPosition(60 /*fps*/);
    const classes = useStyles({ scrollY });
    const { t } = i18n.useTranslation();

    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up(480));

    return (
        <div className={classes.mainContainer}>
            <div className={classes.headerContainer}>
                <Header />
            </div>

            <div className={classes.tagline}>
                <Text className={classes.taglineText} typography={TextTypography.TITLE_STRONG_CHANGE}>
                    {t('pages:contacts.title')}
                </Text>
            </div>
            <div className={classes.additionalContainer}>
                <div className={classes.additionalTitle}>
                    <Text className={classes.additionalTitleText} typography={TextTypography.HUGE_TITLE_BOLD_CHANGE}>
                        {t('pages:contacts.block.title')}
                    </Text>
                </div>
                <div className={classes.additionalSubTitle}>
                    <Text className={classes.additionalTitleText} typography={TextTypography.TITLE_ACCENT_CHANGE}>
                        {t('pages:contacts.block.subTitle')}
                    </Text>
                </div>
                <div className={classes.additionalSubTitle}>
                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>{t('pages:contacts.block.text1')}</Text>
                </div>
                <div className={classes.additionalSubTitle}>
                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>{t('pages:contacts.block1.text1')}</Text>
                </div>
                <div className={classes.additionalSubTitle}>
                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>{t('pages:contacts.block1.text2')}</Text>
                </div>
                <div className={classes.grid}>
                    {isLargeScreen ? (
                        <Grid container item spacing={4}>
                            <Grid item xs={6}>
                                <img className={classes.contactImg} src={Foto_1} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block2.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block2.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <img className={classes.contactImg} src={Foto_2} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block3.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block3.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <img className={classes.contactImg} src={Foto_3} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block4.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block4.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <img className={classes.contactImg} src={Foto_4} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block5.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block5.text1')}
                                    </Text>
                                </div>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container item spacing={3}>
                            <Grid item xs={12}>
                                <img className={classes.contactImg} src={Foto_1} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block2.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block2.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <img className={classes.contactImg} src={Foto_2} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block3.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block3.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <img className={classes.contactImg} src={Foto_3} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block4.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block4.text1')}
                                    </Text>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <img className={classes.contactImg} src={Foto_4} alt={t('common:photoAltHuman')} />
                                <div className={classes.contactTitle}>
                                    <Text typography={TextTypography.TITLE_ACCENT_CHANGE}>
                                        {t('pages:contacts.block5.title')}
                                    </Text>
                                </div>
                                <div className={classes.contactSubTitle}>
                                    <Text typography={TextTypography.TEXT_BODY_REGULAR_CHANGE}>
                                        {t('pages:contacts.block5.text1')}
                                    </Text>
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </div>
            </div>
            <div className={classes.footerContainer}>
                <FooterInternalPages />
            </div>
        </div>
    );
};
